import React from 'react'
import { useMyHook } from '../NewContext'
import { Swiper, SwiperSlide } from "swiper/react"
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from "swiper";
import reviews_data from '../Data/website_reviews'

const ReviewsBlock = () => {

  const { windowSize } = useMyHook()

  return (
    <>
        <div className="container reviews-container">
            <h3 className="section-subtitle">AutoInsure</h3>
            <h1 className="section-title">Customer Reviews</h1>
            <p className="section-caption reviews-caption">Here are some reviews of the experience that some previous customers had with AutoInsure! See below:</p>
            <div className="reviews-box">
                <Swiper spaceBetween={10} slidesPerView={windowSize > 1024 ? 3 : 1} modules={[Pagination]} pagination={{ clickable: true }}>
                    {reviews_data.map((i) => {
                        return (
                            <SwiperSlide>
                                <div key={i.id} id={i.id} className="review-card">
                                    <div className="review-top-container">
                                        <div className="review-img-container">
                                            <img src={i.img} alt="customer" />
                                        </div>
                                        <div className="review-customer-container">
                                            <h5 className="customer-title">{i.name}</h5>
                                            <p className="customer-job">{i.job}</p>
                                            <span className="customer-rating">
                                                {i.rating_stars}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="review-bottom-container">
                                        <h4 className="review-title">{i.review_title}</h4>
                                        <p className="review-contents">"{i.desc}"</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })}
                    {/* <SwiperSlide>
                        <div className="review-card">
                            <div className="review-top-container">
                                <div className="review-img-container">
                                    <img src={customer_pic} alt="customer" />
                                </div>
                                <div className="review-customer-container">
                                    <h5 className="customer-title">Bill Wingrove</h5>
                                    <p className="customer-job">Customer</p>
                                    <span className="customer-rating">
                                        <BsStarFill/>
                                        <BsStarFill/>
                                        <BsStarFill/>
                                        <BsStarHalf/>
                                        <BsStar/>
                                    </span>
                                </div>
                            </div>
                            <div className="review-bottom-container">
                                <h4 className="review-title">Amazing Service!</h4>
                                <p className="review-contents">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ullam, ratione.</p>
                            </div>
                        </div>
                    </SwiperSlide> */}
                </Swiper>
            </div>
        </div>
    </>
  )
}

export default ReviewsBlock